import { render, staticRenderFns } from "./RedeemedAwardDetailModal.vue?vue&type=template&id=df5c5fce&scoped=true"
import script from "./RedeemedAwardDetailModal.vue?vue&type=script&lang=js"
export * from "./RedeemedAwardDetailModal.vue?vue&type=script&lang=js"
import style0 from "./RedeemedAwardDetailModal.vue?vue&type=style&index=0&id=df5c5fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5c5fce",
  null
  
)

export default component.exports